import { yupResolver } from "@hookform/resolvers/yup";
import { Dialog, DialogContent, Stack, DialogActions } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { YupShape, DialogTitle, FormInput, FormButton } from "suregifts-component-lib";
import * as yup from "yup";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { ConfigureCategoryModel, useConfigureCategory } from "../../../../services/utility";
import { OnOffSelectControl } from "../../../../components/molecules/OnOffSelectControl";

export const campaignSchema = yup
  .object<YupShape<ConfigureCategoryModel>>({
    name: yup.string().required(),
  })
  .required();
const ConfigureModal = ({}) => {
  const { state } = useLocation();
  const formMethods = useForm<ConfigureCategoryModel>({
    resolver: yupResolver(campaignSchema),
    values: state?.data,
  });
  const {
    formState: { errors, isValid },
    register,
    handleSubmit,
  } = formMethods;
  const queryClient = useQueryClient();

  const { mutate: configureCategory, isLoading } = useConfigureCategory();

  const submitForm = (data) => {
    configureCategory(data, {
      onSuccess: () => {
        toast.success("Esim configured successfully.");
        queryClient.invalidateQueries("bill-categories");
        handleClose();
      },
    });
  };

  const nagivate = useNavigate();
  const handleClose = () => {
    if (isLoading) return;
    nagivate("./");
  };

  return (
    <FormProvider {...formMethods}>
      <Dialog open maxWidth={"xs"} onClose={handleClose}>
        <DialogTitle title={`Configure Esim`} handleClose={handleClose} />
        <DialogContent>
          <Stack spacing={2}>
            <FormInput label="Name" {...register("name")} helperText={errors.name?.message} />
            <OnOffSelectControl label="Is Active" name="isActive" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <FormButton label="Submit" disabled={!isValid} loading={isLoading} fullWidth onClick={handleSubmit(submitForm)} />
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
};
export default ConfigureModal;
